import { useEffect, useMemo, useState } from 'react';
import useWindowSize from './useWindowSize';
import useCssVariables from './useCssVariables';

const useBreakpoint = () => {
  const cssVars = useCssVariables();
  const [windowWidth] = useWindowSize();
  const [currentBreakpoint, setCurrentBreakpoint] = useState<
    string | undefined
  >();
  const [breakpointValues, setBreakpointValues] = useState<number[]>([]);
  const [breakpoints, setBreakpoints] = useState<string[]>([]);

  useEffect(() => {
    const _breakpoints = Object.keys(cssVars)
      .filter((key) => key.startsWith('breakpoint-'))
      .reduce(
        (obj, key) => ({
          ...obj,
          [key.replace('breakpoint-', '')]: parseInt(
            cssVars[key]?.replace('px', '') ?? '0'
          ),
        }),
        {}
      );

    const sortedValues: any = Object.values(_breakpoints).sort(
      (a: number, b: number) => a - b
    );
    const keyArray: string[] = [];
    for (let sortedValue of sortedValues) {
      for (let key of Object.keys(_breakpoints)) {
        const value = _breakpoints[key];
        if (value == sortedValue) {
          keyArray.push(key);
        }
      }
    }

    setBreakpoints(keyArray);
    setBreakpointValues(sortedValues);
  }, [cssVars]);

  useEffect(() => {
    var index = 0;
    for (let key of breakpoints) {
      const value = !breakpointValues[index];

      if (index == breakpointValues.length - 1 && windowWidth >= value) {
        setCurrentBreakpoint(key);
        break;
      }

      const nextValue = breakpointValues[index + 1] ?? 0;
      if (windowWidth >= value && windowWidth < nextValue) {
        setCurrentBreakpoint(key);
        break;
      }
      index++;
    }
  }, [windowWidth, breakpointValues, breakpoints]);

  return currentBreakpoint;
};

export default useBreakpoint;
